import * as Long from "long";
import { ofType } from "redux-observable";
import { concat, from } from "rxjs";
import { filter, mapTo, switchMap, take } from "rxjs/operators";
import { IdResource } from "../../../constants/IdResource";
import { selectModalTabId } from "../../../selectors/selectModalTabId";
import { selectNotEnoughResourcesMissingResources } from "../../../selectors/selectNotEnoughResources";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionNotEnoughResource, } from "../../not-enough-resource/actionNotEnoughResource";
import { IdMissingResourceTypes } from "../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../ongoing-purchase/actionOngoingPurchase";
import { actionDoghouseGiveTreat, TypeActionDoghouse } from "../actionDoghouse";
import { DoghouseCategory } from "../DoghouseCategory";
export var epicDoghouseNotEnoughTreat = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionDoghouse.NotEnoughTreat), switchMap(function () {
        var state = state$.value;
        var selectedDoghouseMenuTabId = selectModalTabId(state, IdModal.Doghouse);
        var missingDogTreat = selectNotEnoughResourcesMissingResources(state, [
            {
                amount: Long.ONE,
                typeId: selectedDoghouseMenuTabId === DoghouseCategory.GiveDoghouseBonePrm
                    ? IdResource.DogtreatPremium
                    : IdResource.DogtreatStandard,
            },
        ]);
        return concat(from([
            actionOngoingPurchaseStandardSelect([
                {
                    missingResources: missingDogTreat,
                    missingType: IdMissingResourceTypes.Resources,
                },
            ]),
            actionModalOpen(IdModal.NotEnoughResource),
        ]), action$.pipe(ofType(TypeActionNotEnoughResource.BuyWithGoldComplete), take(1), filter(function (notEnoughResourceAction) {
            return notEnoughResourceAction.isPurchased;
        }), mapTo(actionDoghouseGiveTreat())));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/epics/epicDoghouseNotEnoughTreat.ts
// module id = 1839
// module chunks = 3